module.exports = __webpack_public_path__ + "/login_ui/img/ve-34ff7eb1678cda6b045187378889a6db.svg";